(() => {
'use strict';
if (window.NoyafaBrandScene) {
  window.NoyafaBrandScene.init();
  return;
}
const SCENE_W = 1672;
const SCENE_H = 941;
const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
function strokePath(ctx, points) {
    ctx.beginPath();
    points.forEach(([x, y], index) => {
        if (index === 0)
            ctx.moveTo(x, y);
        else
            ctx.lineTo(x, y);
    });
}
function pointOnPath(points, progress) {
    const lengths = [];
    let total = 0;
    for (let index = 1; index < points.length; index += 1) {
        const [x0, y0] = points[index - 1];
        const [x1, y1] = points[index];
        const length = Math.hypot(x1 - x0, y1 - y0);
        lengths.push(length);
        total += length;
    }
    let target = ((progress % 1) + 1) % 1 * total;
    for (let index = 0; index < lengths.length; index += 1) {
        if (target <= lengths[index]) {
            const [x0, y0] = points[index];
            const [x1, y1] = points[index + 1];
            const local = target / lengths[index];
            return {
                x: x0 + (x1 - x0) * local,
                y: y0 + (y1 - y0) * local,
                angle: Math.atan2(y1 - y0, x1 - x0),
            };
        }
        target -= lengths[index];
    }
    const [x0, y0] = points[points.length - 2];
    const [x1, y1] = points[points.length - 1];
    return { x: x1, y: y1, angle: Math.atan2(y1 - y0, x1 - x0) };
}
function drawSignalTrail(ctx, points, progress, color, length = 11, width = 2, reverse = false) {
    const direction = reverse ? -1 : 1;
    ctx.save();
    for (let index = 7; index >= 0; index -= 1) {
        const p = pointOnPath(points, progress - direction * index * 0.006);
        const strength = (8 - index) / 8;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.angle + (reverse ? Math.PI : 0));
        ctx.globalAlpha *= strength * strength;
        ctx.shadowColor = color;
        ctx.shadowBlur = 5;
        ctx.fillStyle = color;
        ctx.beginPath();
        ctx.roundRect(-length * strength * 0.5, -width * 0.5, length * strength, width, width);
        ctx.fill();
        ctx.restore();
    }
    ctx.restore();
}
const copperTop = [
    [70, 378],
    [190, 378],
    [225, 380],
    [250, 391],
    [269, 411],
    [277, 437],
    [277, 490],
];
const copperLower = [
    [71, 386],
    [194, 386],
    [228, 389],
    [250, 399],
    [267, 418],
    [270, 467],
];
const fiberTop = [
    [70, 363],
    [190, 363],
    [223, 366],
    [247, 376],
    [264, 391],
    [271, 413],
    [271, 467],
];
const rackVerticals = [
    [[144, 489], [144, 533], [147, 575], [147, 630]],
    [[158, 489], [158, 532], [160, 574], [160, 630]],
    [[202, 489], [201, 532], [203, 575], [202, 630]],
];
const undergroundPath = [
    [464, 577],
    [585, 631],
    [716, 690],
    [852, 748],
    [990, 805],
    [1135, 850],
    [1282, 881],
    [1422, 906],
    [1550, 914],
    [1672, 914],
];
const laserPath = [
    [466, 534],
    [610, 590],
    [752, 647],
    [887, 700],
    [1018, 750],
];
function drawNetworkAndFiber(ctx, time, alpha) {
    ctx.save();
    ctx.globalAlpha = alpha;
    ctx.beginPath();
    ctx.rect(48, 342, 242, 305);
    ctx.clip();
    [copperTop, copperLower].forEach((path, index) => {
        strokePath(ctx, path);
        ctx.strokeStyle = "rgba(37,139,255,.26)";
        ctx.lineWidth = 1.1;
        ctx.stroke();
        for (let pulse = 0; pulse < 3; pulse += 1) {
            drawSignalTrail(ctx, path, time * 0.18 + pulse / 3 + index * 0.08, pulse === 1 ? "#b7e8ff" : "#3b9dff", 9, pulse === 1 ? 1.3 : 2);
        }
    });
    strokePath(ctx, fiberTop);
    ctx.strokeStyle = "rgba(255,201,67,.3)";
    ctx.lineWidth = 1.1;
    ctx.stroke();
    drawSignalTrail(ctx, fiberTop, time * 0.22, "#e8fdff", 14, 1.4);
    drawSignalTrail(ctx, fiberTop, 1 - time * 0.14, "#72e8f8", 7, 1, true);
    rackVerticals.forEach((path, index) => {
        strokePath(ctx, path);
        ctx.strokeStyle = "rgba(41,148,255,.2)";
        ctx.lineWidth = 1;
        ctx.stroke();
        drawSignalTrail(ctx, path, time * 0.2 + index * 0.27, "#4aa8ff", 7, 1.7);
    });
    ctx.restore();
}
function drawUndergroundCurrent(ctx, time, alpha) {
    ctx.save();
    ctx.globalAlpha = alpha;
    strokePath(ctx, undergroundPath);
    ctx.strokeStyle = "rgba(255,153,48,.13)";
    ctx.lineWidth = 1.4;
    ctx.stroke();
    for (let index = 0; index < 8; index += 1) {
        const progress = time * 0.13 + index / 8;
        drawSignalTrail(ctx, undergroundPath, progress, index % 3 === 1 ? "#fff2c1" : "#ff9b35", index % 3 === 1 ? 8 : 13, index % 3 === 1 ? 1.4 : 2.1);
    }
    for (let index = 0; index < 28; index += 1) {
        const progress = index / 27;
        const point = pointOnPath(undergroundPath, progress);
        const wave = Math.sin(progress * Math.PI * 15 - time * 5) * 1.5;
        ctx.fillStyle = "rgba(255,190,89,.28)";
        ctx.beginPath();
        ctx.arc(point.x, point.y + wave, 0.75, 0, Math.PI * 2);
        ctx.fill();
    }
    ctx.restore();
}
function drawLaserMeasurement(ctx, time, alpha) {
    const first = laserPath[0];
    const last = laserPath[laserPath.length - 1];
    ctx.save();
    ctx.globalAlpha = alpha;
    strokePath(ctx, laserPath);
    ctx.strokeStyle = "rgba(255,47,65,.78)";
    ctx.lineWidth = 0.85;
    ctx.shadowColor = "rgba(255,35,55,.7)";
    ctx.shadowBlur = 4;
    ctx.stroke();
    ctx.shadowBlur = 0;
    drawSignalTrail(ctx, laserPath, time * 0.24, "#fff0ec", 10, 1.2);
    ctx.strokeStyle = "rgba(255,102,113,.86)";
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(first[0] - 9, first[1] + 13);
    ctx.lineTo(first[0] + 9, first[1] - 13);
    ctx.moveTo(last[0] - 9, last[1] + 13);
    ctx.lineTo(last[0] + 9, last[1] - 13);
    ctx.stroke();
    ctx.fillStyle = "#fff0ea";
    ctx.shadowColor = "#ff3447";
    ctx.shadowBlur = 7;
    ctx.beginPath();
    ctx.arc(last[0], last[1], 2.2, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
}
function drawCctvTesting(ctx, time, alpha) {
    const lensX = 315;
    const lensY = 214;
    const settle = 1 - 0.22 * (0.5 + 0.5 * Math.sin(time * 2.1));
    const width = 77 * settle;
    const height = 48 * settle;
    ctx.save();
    ctx.globalAlpha = alpha;
    ctx.strokeStyle = "rgba(134,229,244,.78)";
    ctx.lineWidth = 0.9;
    const corner = 10;
    const left = lensX - width / 2;
    const top = lensY - height / 2;
    const right = lensX + width / 2;
    const bottom = lensY + height / 2;
    ctx.beginPath();
    ctx.moveTo(left + corner, top);
    ctx.lineTo(left, top);
    ctx.lineTo(left, top + corner);
    ctx.moveTo(right - corner, top);
    ctx.lineTo(right, top);
    ctx.lineTo(right, top + corner);
    ctx.moveTo(left, bottom - corner);
    ctx.lineTo(left, bottom);
    ctx.lineTo(left + corner, bottom);
    ctx.moveTo(right - corner, bottom);
    ctx.lineTo(right, bottom);
    ctx.lineTo(right, bottom - corner);
    ctx.stroke();
    ctx.strokeStyle = "rgba(221,251,255,.84)";
    ctx.beginPath();
    ctx.arc(lensX, lensY, 7 + Math.sin(time * 2.8) * 1.2, 0, Math.PI * 2);
    ctx.moveTo(lensX - 12, lensY);
    ctx.lineTo(lensX + 12, lensY);
    ctx.moveTo(lensX, lensY - 12);
    ctx.lineTo(lensX, lensY + 12);
    ctx.stroke();
    const scanY = top + ((time * 0.24) % 1) * height;
    ctx.strokeStyle = "rgba(95,226,246,.45)";
    ctx.beginPath();
    ctx.moveTo(left + 4, scanY);
    ctx.lineTo(right - 4, scanY);
    ctx.stroke();
    ctx.restore();
}
function wallPolygon(ctx) {
    ctx.beginPath();
    ctx.moveTo(711, 251);
    ctx.lineTo(881, 228);
    ctx.lineTo(881, 647);
    ctx.lineTo(711, 663);
    ctx.closePath();
}
function drawWallDetection(ctx, time, alpha) {
    const sweep = 0.5 - 0.5 * Math.cos(time * Math.PI * 0.72);
    const scanX = 737 + sweep * 111;
    ctx.save();
    ctx.globalAlpha = alpha;
    wallPolygon(ctx);
    ctx.clip();
    ctx.beginPath();
    ctx.rect(scanX - 27, 350, 54, 246);
    ctx.clip();
    const field = ctx.createLinearGradient(scanX - 27, 0, scanX + 27, 0);
    field.addColorStop(0, "rgba(19,86,105,0)");
    field.addColorStop(0.5, "rgba(24,103,124,.32)");
    field.addColorStop(1, "rgba(19,86,105,0)");
    ctx.fillStyle = field;
    ctx.fillRect(scanX - 27, 350, 54, 246);
    ctx.strokeStyle = "rgba(165,225,234,.68)";
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(794, 352);
    ctx.lineTo(794, 595);
    ctx.stroke();
    ctx.strokeStyle = "rgba(67,181,229,.72)";
    ctx.lineWidth = 2.5;
    ctx.beginPath();
    ctx.moveTo(744, 563);
    ctx.bezierCurveTo(770, 526, 819, 523, 852, 486);
    ctx.stroke();
    ctx.restore();
    ctx.save();
    ctx.globalAlpha = alpha;
    ctx.strokeStyle = "rgba(213,251,255,.9)";
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(scanX, 354);
    ctx.lineTo(scanX, 592);
    ctx.stroke();
    ctx.strokeStyle = "rgba(100,224,241,.46)";
    ctx.strokeRect(scanX - 22, 407, 44, 126);
    const distance = Math.abs(scanX - 794);
    if (distance < 22) {
        const lockAlpha = 1 - distance / 22;
        ctx.globalAlpha *= lockAlpha;
        ctx.strokeStyle = "rgba(224,253,255,.96)";
        ctx.beginPath();
        ctx.arc(794, 471, 12 + (1 - lockAlpha) * 5, 0, Math.PI * 2);
        ctx.moveTo(775, 471);
        ctx.lineTo(813, 471);
        ctx.moveTo(794, 452);
        ctx.lineTo(794, 490);
        ctx.stroke();
    }
    ctx.restore();
}
function drawGasDetection(ctx, time, alpha) {
    ctx.save();
    ctx.globalAlpha = alpha;
    ctx.globalCompositeOperation = "screen";
    for (let index = 0; index < 18; index += 1) {
        const lane = index % 6;
        const progress = (time * 0.16 + Math.floor(index / 6) * 0.31) % 1;
        const x = 1375 + lane * 27 + Math.sin(time * 1.6 + index) * 3.5;
        const y = 218 + progress * 100;
        ctx.fillStyle = `rgba(126,232,241,${0.46 * (1 - progress)})`;
        ctx.beginPath();
        ctx.arc(x, y, 1 + progress * 1.1, 0, Math.PI * 2);
        ctx.fill();
    }
    for (let index = 0; index < 3; index += 1) {
        const pulse = (time * 0.22 + index / 3) % 1;
        ctx.strokeStyle = `rgba(105,230,222,${0.36 * (1 - pulse)})`;
        ctx.lineWidth = 0.8;
        ctx.beginPath();
        ctx.ellipse(1442, 282, 18 + pulse * 44, 6 + pulse * 12, 0, 0, Math.PI * 2);
        ctx.stroke();
    }
    ctx.restore();
}
function drawThermalImaging(ctx, time, alpha) {
    const pulse = 0.92 + Math.sin(time * 1.9) * 0.045;
    ctx.save();
    ctx.globalAlpha = alpha * 0.84;
    ctx.globalCompositeOperation = "screen";
    ctx.translate(1387, 623);
    ctx.scale(1.5 * pulse, 0.82 * pulse);
    const heat = ctx.createRadialGradient(0, 0, 8, 0, 0, 92);
    heat.addColorStop(0, "rgba(255,247,158,.88)");
    heat.addColorStop(0.18, "rgba(255,177,29,.72)");
    heat.addColorStop(0.46, "rgba(255,73,25,.38)");
    heat.addColorStop(0.74, "rgba(222,20,54,.2)");
    heat.addColorStop(1, "rgba(180,10,55,0)");
    ctx.fillStyle = heat;
    ctx.beginPath();
    ctx.arc(0, 0, 92, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
    ctx.save();
    ctx.globalAlpha = alpha * 0.72;
    ctx.globalCompositeOperation = "screen";
    const bearingHeat = ctx.createRadialGradient(1482, 624, 2, 1482, 624, 43);
    bearingHeat.addColorStop(0, "rgba(255,251,194,.92)");
    bearingHeat.addColorStop(0.24, "rgba(255,188,38,.68)");
    bearingHeat.addColorStop(0.62, "rgba(255,66,24,.28)");
    bearingHeat.addColorStop(1, "rgba(255,40,32,0)");
    ctx.fillStyle = bearingHeat;
    ctx.beginPath();
    ctx.arc(1482, 624, 43, 0, Math.PI * 2);
    ctx.fill();
    ctx.strokeStyle = "rgba(255,179,68,.54)";
    ctx.lineWidth = 1.35;
    for (let index = 0; index < 3; index += 1) {
        const offset = index * 38;
        const rise = ((time * 17 + offset) % 43) - 12;
        ctx.globalAlpha = alpha * (1 - clamp((rise + 12) / 55)) * 0.65;
        ctx.beginPath();
        ctx.moveTo(1347 + offset, 577 - rise);
        ctx.bezierCurveTo(1334 + offset, 563 - rise, 1362 + offset, 553 - rise, 1348 + offset, 538 - rise);
        ctx.stroke();
    }
    ctx.restore();
}
function drawScene(ctx, time) {
    const alpha = 1;
    ctx.clearRect(0, 0, SCENE_W, SCENE_H);
    drawNetworkAndFiber(ctx, time, alpha);
    drawCctvTesting(ctx, time, alpha);
    drawWallDetection(ctx, time, alpha);
    drawLaserMeasurement(ctx, time, alpha);
    drawUndergroundCurrent(ctx, time, alpha);
    drawThermalImaging(ctx, time, alpha);
    drawGasDetection(ctx, time, alpha);
}
function mountBrandScene(canvas) {
    if (canvas.dataset.sceneMounted === "true")
        return;
    const context = canvas.getContext("2d");
    if (!context)
        return;
    canvas.dataset.sceneMounted = "true";
    const viewport = canvas.closest("[data-brand-scene]");
    const camera = viewport?.querySelector("[data-brand-scene-camera]");
    const readout = viewport?.querySelector(".brand-scene-mobile-readout");
    const caption = viewport?.querySelector("[data-brand-scene-caption]");
    const captionIndex = viewport?.querySelector("[data-brand-scene-index]");
    const labels = Array.from(viewport?.querySelectorAll("[data-scene-group]") || []);
    const viewSwitch = viewport?.querySelector("[data-brand-scene-view-switch]");
    const viewButtons = Array.from(viewport?.querySelectorAll("[data-brand-scene-view]") || []);
    const mobileMode = window.matchMedia("(max-width: 640px)");
    const reducedMotion = false;
    let frame = 0;
    let running = false;
    let inViewport = false;
    let sceneTime = 0;
    let previousFrame = 0;
    let activeState = 0;
    let autoDirection = 1;
    let nextAutoAt = performance.now() + 4500;
    let cameraPan = 0;
    let pointerId = null;
    let pointerStartX = 0;
    let pointerStartY = 0;
    let pointerStartTime = 0;
    let pointerStartPan = 0;
    let pointerStartState = 0;
    let dragging = false;
    let labelSafetyFrame = 0;

    const cameraRange = () => {
        if (!camera || !viewport)
            return 0;
        return Math.max(0, camera.getBoundingClientRect().width - viewport.clientWidth);
    };
    const readCameraPan = () => {
        const range = cameraRange();
        if (!range || !camera)
            return 0;
        try {
            const matrix = new DOMMatrixReadOnly(getComputedStyle(camera).transform);
            return clamp(-matrix.m41 / range);
        }
        catch {
            return cameraPan;
        }
    };
    const applyCameraPan = (pan, animate = true) => {
        if (!camera)
            return;
        const nextPan = clamp(pan);
        const range = cameraRange();
        const distance = Math.abs(nextPan - cameraPan);
        camera.style.transition = animate
            ? `transform ${Math.round(620 + distance * 430)}ms cubic-bezier(.22,.74,.18,1)`
            : "none";
        camera.style.transform = `translate3d(${-range * nextPan}px, 0, 0)`;
        cameraPan = nextPan;
    };
    const captionFor = (state) => {
        const button = viewButtons[state];
        return button?.getAttribute("aria-label")?.trim() || caption?.textContent?.trim() || "";
    };
    const fitLabelsClearOfReadout = () => {
        cancelAnimationFrame(labelSafetyFrame);
        labels.forEach((label) => label.style.removeProperty("--scene-safe-shift"));
        if (!mobileMode.matches || !readout)
            return;
        labelSafetyFrame = requestAnimationFrame(() => {
            const readoutTop = readout.getBoundingClientRect().top;
            labels
                .filter((label) => label.classList.contains("is-active"))
                .forEach((label) => {
                    const overlap = label.getBoundingClientRect().bottom - readoutTop + 14;
                    if (overlap > 0)
                        label.style.setProperty("--scene-safe-shift", `${-Math.ceil(overlap)}px`);
                });
        });
    };
    const updatePresentation = (state) => {
        const nextState = Math.round(clamp(state, 0, 2));
        activeState = nextState;
        viewport?.setAttribute("data-scene-view", String(nextState));
        labels.forEach((label) => {
            label.classList.toggle("is-active", Number(label.dataset.sceneGroup) === nextState);
        });
        viewButtons.forEach((button, index) => {
            const selected = index === nextState;
            button.classList.toggle("is-active", selected);
            button.setAttribute("aria-pressed", String(selected));
        });
        if (caption)
            caption.textContent = captionFor(nextState);
        if (captionIndex)
            captionIndex.textContent = `0${nextState + 1} / 03`;
        fitLabelsClearOfReadout();
    };
    const setSceneState = (state, { animate = true, manual = false } = {}) => {
        const nextState = Math.round(clamp(state, 0, 2));
        updatePresentation(nextState);
        if (mobileMode.matches)
            applyCameraPan(nextState / 2, animate);
        if (nextState === 0)
            autoDirection = 1;
        else if (nextState === 2)
            autoDirection = -1;
        if (manual)
            nextAutoAt = performance.now() + 8000;
    };
    const syncSceneMode = () => {
        const isMobile = mobileMode.matches;
        canvas.dataset.sceneMobile = String(isMobile);
        viewport?.classList.toggle("is-mobile-scene", isMobile);
        if (!camera)
            return;
        if (!isMobile) {
            camera.style.removeProperty("transition");
            camera.style.removeProperty("transform");
            cameraPan = 0;
            return;
        }
        applyCameraPan(activeState / 2, false);
    };
    const advanceAutoCamera = (now) => {
        if (!mobileMode.matches || dragging || now < nextAutoAt)
            return;
        const nextState = activeState + autoDirection;
        setSceneState(nextState, { animate: true });
        nextAutoAt = now + 5200;
    };
    const resizeCanvas = () => {
        const bounds = canvas.getBoundingClientRect();
        if (!bounds.width || !bounds.height)
            return;
        const ratio = Math.min(window.devicePixelRatio || 1, 1.35);
        const width = Math.max(1, Math.round(bounds.width * ratio));
        const height = Math.max(1, Math.round(bounds.height * ratio));
        if (canvas.width !== width || canvas.height !== height) {
            canvas.width = width;
            canvas.height = height;
            context.setTransform(width / SCENE_W, 0, 0, height / SCENE_H, 0, 0);
        }
        syncSceneMode();
        fitLabelsClearOfReadout();
        drawScene(context, reducedMotion ? 2.8 : sceneTime);
    };
    const render = (now) => {
        if (!previousFrame)
            previousFrame = now;
        sceneTime += Math.min(40, Math.max(0, now - previousFrame)) / 1000;
        previousFrame = now;
        const time = reducedMotion ? 2.8 : sceneTime;
        advanceAutoCamera(now);
        drawScene(context, time);
        if (!reducedMotion && running)
            frame = requestAnimationFrame(render);
    };
    const syncPlayback = () => {
        const shouldRun = inViewport && !document.hidden && !reducedMotion;
        if (shouldRun === running)
            return;
        running = shouldRun;
        cancelAnimationFrame(frame);
        if (running) {
            previousFrame = performance.now();
            frame = requestAnimationFrame(render);
        }
        else {
            previousFrame = 0;
            drawScene(context, reducedMotion ? 2.8 : sceneTime);
        }
    };
    const resetPointer = () => {
        if (pointerId !== null && viewport?.hasPointerCapture?.(pointerId))
            viewport.releasePointerCapture(pointerId);
        pointerId = null;
        dragging = false;
        viewport?.classList.remove("is-dragging");
    };
    const onPointerDown = (event) => {
        if (!mobileMode.matches || event.isPrimary === false)
            return;
        pointerId = event.pointerId;
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
        pointerStartTime = performance.now();
        pointerStartPan = readCameraPan();
        pointerStartState = activeState;
        dragging = false;
        applyCameraPan(pointerStartPan, false);
    };
    const onPointerMove = (event) => {
        if (event.pointerId !== pointerId || !mobileMode.matches)
            return;
        const deltaX = event.clientX - pointerStartX;
        const deltaY = event.clientY - pointerStartY;
        if (!dragging) {
            if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > 9) {
                resetPointer();
                return;
            }
            if (Math.abs(deltaX) < 9)
                return;
            dragging = true;
            viewport?.classList.add("is-dragging");
            viewport?.setPointerCapture?.(event.pointerId);
        }
        event.preventDefault();
        const range = Math.max(1, cameraRange());
        const pan = clamp(pointerStartPan - deltaX / range);
        applyCameraPan(pan, false);
        updatePresentation(Math.round(pan * 2));
    };
    const finishPointer = (event, cancelled = false) => {
        if (event.pointerId !== pointerId)
            return;
        if (!dragging || cancelled) {
            resetPointer();
            if (cancelled)
                setSceneState(activeState, { animate: true });
            return;
        }
        const deltaX = event.clientX - pointerStartX;
        const elapsed = Math.max(1, performance.now() - pointerStartTime);
        const velocity = deltaX / elapsed;
        let target = Math.round(cameraPan * 2);
        if (Math.abs(deltaX) >= 42 || Math.abs(velocity) >= 0.34)
            target = pointerStartState + (deltaX < 0 ? 1 : -1);
        resetPointer();
        setSceneState(target, { animate: true, manual: true });
    };
    const onPointerUp = (event) => finishPointer(event, false);
    const onPointerCancel = (event) => finishPointer(event, true);
    const onViewClick = (event) => {
        const button = event.currentTarget;
        setSceneState(Number(button.dataset.brandSceneView), { animate: true, manual: true });
    };
    const onViewKeyDown = (event) => {
        if (event.key !== "ArrowLeft" && event.key !== "ArrowRight")
            return;
        event.preventDefault();
        const direction = event.key === "ArrowRight" ? 1 : -1;
        const target = clamp(activeState + direction, 0, 2);
        setSceneState(target, { animate: true, manual: true });
        viewButtons[target]?.focus({ preventScroll: true });
    };
    const onModeChange = () => {
        resetPointer();
        resizeCanvas();
        setSceneState(activeState, { animate: false });
    };
    const visibilityObserver = new IntersectionObserver((entries) => {
        inViewport = entries.some((entry) => entry.isIntersecting);
        viewport?.classList.toggle("is-scene-active", inViewport);
        syncPlayback();
    }, { rootMargin: "360px 0px", threshold: 0 });
    const resizeObserver = "ResizeObserver" in window
        ? new ResizeObserver(resizeCanvas)
        : null;
    const labelSafetyObserver = "ResizeObserver" in window
        ? new ResizeObserver(fitLabelsClearOfReadout)
        : null;
    setSceneState(0, { animate: false });
    resizeCanvas();
    drawScene(context, reducedMotion ? 2.8 : 0);
    visibilityObserver.observe(canvas);
    resizeObserver?.observe(canvas);
    if (readout)
        labelSafetyObserver?.observe(readout);
    labels.forEach((label) => labelSafetyObserver?.observe(label));
    viewport?.addEventListener("pointerdown", onPointerDown);
    viewport?.addEventListener("pointermove", onPointerMove, { passive: false });
    viewport?.addEventListener("pointerup", onPointerUp);
    viewport?.addEventListener("pointercancel", onPointerCancel);
    viewButtons.forEach((button) => button.addEventListener("click", onViewClick));
    viewSwitch?.addEventListener("keydown", onViewKeyDown);
    mobileMode.addEventListener?.("change", onModeChange);
    document.addEventListener("visibilitychange", syncPlayback);
    window.addEventListener("resize", resizeCanvas, { passive: true });
    window.addEventListener("pagehide", () => {
        running = false;
        cancelAnimationFrame(frame);
        visibilityObserver.disconnect();
        resizeObserver?.disconnect();
        labelSafetyObserver?.disconnect();
        cancelAnimationFrame(labelSafetyFrame);
        viewport?.removeEventListener("pointerdown", onPointerDown);
        viewport?.removeEventListener("pointermove", onPointerMove);
        viewport?.removeEventListener("pointerup", onPointerUp);
        viewport?.removeEventListener("pointercancel", onPointerCancel);
        viewButtons.forEach((button) => button.removeEventListener("click", onViewClick));
        viewSwitch?.removeEventListener("keydown", onViewKeyDown);
        mobileMode.removeEventListener?.("change", onModeChange);
        document.removeEventListener("visibilitychange", syncPlayback);
        window.removeEventListener("resize", resizeCanvas);
    }, { once: true });
}
function initBrandScenes() {
    document
        .querySelectorAll("[data-brand-scene-canvas]")
        .forEach(mountBrandScene);
}
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBrandScenes, { once: true });
}
else {
    initBrandScenes();
}

window.NoyafaBrandScene = { init: initBrandScenes };
document.addEventListener('shopify:section:load', initBrandScenes);
})();
